import React, { useEffect, useState } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { withStyles } from '@material-ui/core';
import { locationStockInitQuery } from './queries';
import styles from './styles';
import ViewStockComponent from '../../../components/Global/Stock';
import { Dashboard } from '../../../layouts';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

enum InventoryRestockEnum {
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

const ViewLocationStock = ({ classes }: Props): React.ReactElement => {
  const [locationId, setLocationId] = useState<string>('');
  const [inventoryRestockType, setInventoryRestockType] = useState<string>('');

  const { data } = useQuery(locationStockInitQuery, { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (data?.locations?.[0]) {
      setLocationId(data.locations[0].id);
      setInventoryRestockType(data.locations[0].inventory_restock_type);
    }
  }, [data]);

  if (!locationId) {
    return <Dashboard title="Stock Management"><div /></Dashboard>;
  }

  return (
    <Dashboard title="Stock Management">
      <ViewStockComponent classes={{}} location_id={locationId} inventory_restock_type={inventoryRestockType as InventoryRestockEnum} />
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(ViewLocationStock));
